// Tiny analytics helper for GA4. Safe no-op if gtag isn't loaded yet (e.g., during dev).
import { API } from './api';

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

// --- Self-hosted tracking (for the in-admin Site Analytics view) ---
const VID_KEY = 'fymua_vid';
const getVisitorId = () => {
  if (typeof window === 'undefined') return '';
  let v = localStorage.getItem(VID_KEY);
  if (!v) {
    v = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VID_KEY, v);
  }
  return v;
};

const beacon = (payload) => {
  try {
    fetch(`${API}/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (_) { /* no-op */ }
};

const collectAttribution = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    return {
      referrer: document.referrer || '',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
    };
  } catch (_) {
    return { referrer: '', utm_source: '', utm_medium: '', utm_campaign: '' };
  }
};

export const trackVisit = (path) => {
  beacon({ type: 'pageview', path, visitor_id: getVisitorId(), ...collectAttribution() });
};

export const trackArtistView = (slug) => {
  if (!slug) return;
  beacon({ type: 'artist_view', path: `/artists/${slug}`, artist_slug: slug, visitor_id: getVisitorId(), ...collectAttribution() });
};

export const trackPageView = (path, title) => {
  if (!hasGtag()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

/**
 * Track a custom event with optional params.
 * Common events used on FindYourMUA:
 *   - whatsapp_click            { source: 'navbar' | 'artist_card' | 'profile' | 'sticky' }
 *   - book_trial_click          { artist_slug }
 *   - enquiry_submit            { city }
 *   - register_artist_click     { source }
 *   - share_profile_click       { artist_slug }
 *   - artist_card_view          { artist_slug }
 */
export const trackEvent = (name, params = {}) => {
  if (!hasGtag()) return;
  window.gtag('event', name, params);
};
